import { Icon } from '~/components/icon'
import type { InputSelectSize } from '../../types'
import { onClearVariants } from './clear-button-styles'

export const InputSelectClearButton = ({
  selectedValue,
  onClear,
  disabled,
  readonly,
  size,
  label,
}: {
  selectedValue?: string
  onClear: (event: React.MouseEvent | React.KeyboardEvent) => void
  disabled?: boolean
  readonly?: boolean
  size: InputSelectSize
  label?: InputSelectSize | false
}) => {
  if (!selectedValue) return null

  return (
    <span
      className={onClearVariants({
        size,
        label,
        disabled: false,
        readonly: false,
      })}
      onClick={event => {
        event.stopPropagation()
        onClear(event)
      }}
      onKeyUp={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.stopPropagation()
          onClear(event)
        }
      }}
      role="button"
      aria-label="Limpar seleção"
      tabIndex={0}
      data-testid="button-clear"
    >
      <Icon
        size={size === 'md' ? 'extra-small' : 'small'}
        symbol="rdicon-dismiss-circle-outline"
        color={
          disabled
            ? 'colorTextNeutralDisabled'
            : readonly
              ? 'colorTextNeutralReadonly'
              : 'colorTextNeutralDefault'
        }
      />
    </span>
  )
}
